<template lang="pug">
textarea.form-control(
  :value="value"
  :placeholder="placeholder"
  :rows="rows"
  :id="id"
  @change="change"
  @blur="blur"
)
</template>

<script>
  export default {
    props: {
      value: {
        type: String
      },
      id: {
        type: String,
        required: false
      },
      placeholder: {
        type: String,
        required: false
      },
      rows: {
        type: String,
        default: () => "3"
      },
      stopChangePropagation: {
        type: Boolean,
        default: () => false
      }
    },

    methods: {
      change(event) {
        if(this.stopChangePropagation) event.stopPropagation()

        this.$emit('input', event.target.value);
      },

      blur(event) {
        this.$emit('blur', event.target.value);
      }
    }
  }
</script>
